// removed by extract-text-webpack-plugin
module.exports = {"articleContent":"styles__articleContent___2-9JO","imgContainer":"styles__imgContainer___1zflk","articleFooter":"styles__articleFooter___2RDAm","heading":"styles__heading___5UZU8","header":"styles__header___1R6a4","moreArticles":"styles__moreArticles___tGVK0","postContainer":"styles__postContainer___3nERx","trendingArticles":"styles__trendingArticles___1iui0","trendingHeading":"styles__trendingHeading___3lqFs","bottomAd":"styles__bottomAd___1xTYT","videoElement":"styles__videoElement___11PQ6","videoElementContainer":"styles__videoElementContainer___3tKh1"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/postPreview/styles.css
// module id = kvgJ
// module chunks = 3